import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-TVShowTableColumn-rank',
  },
  {
    name: 'Show Title',
    key: 'title',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-TVShowTableColumn-title',
  },
  {
    name: 'Episodes',
    key: 'episodes',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-TVShowTableColumn-episodes',
  },
  {
    name: 'Passengers (Shows)',
    key: 'passengers_show',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-TVShowTableColumn-passengers',
  },
  {
    name: 'Passengers (Avg episode)',
    key: 'passengers_episode',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-TVShowTableColumn-passengers',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-TVShowTableColumn-passengerPoolPer',
  },
];

const data = [
  {
    rank: '1',
    title: 'Fruits Basket',
    episodes: 8,
    passengers_show: {
      display: '29,580',
      sort: 29580,
    },
    passengers_episode: {
      display: '8,570',
      sort: 8578,
    },
    passenger_pool_per: '5.91%',
  },
  {
    rank: '2',
    title: 'Last modified',
    episodes: 6,
    passengers_show: {
      display: '24,207',
      sort: 24207,
    },
    passengers_episode: {
      display: '7,020',
      sort: 7020,
    },
    passenger_pool_per: '4.84%',
  },
  {
    rank: '3',
    title: 'CMS',
    episodes: 12,
    passengers_show: {
      display: '22,398',
      sort: 22398,
    },
    passengers_episode: {
      display: '6,495',
      sort: 6495,
    },
    passenger_pool_per: '4.50%',
  },
  {
    rank: '4',
    title: "Outchef'd",
    episodes: 2,
    passengers_show: {
      display: '22,158',
      sort: 22158,
    },
    passengers_episode: {
      display: '6,425',
      sort: 6425,
    },
    passenger_pool_per: '4.41%',
  },
  {
    rank: '5',
    title: 'Black clover',
    episodes: 7,
    passengers_show: {
      display: '17,700',
      sort: 17700,
    },
    passengers_episode: {
      display: '5,133',
      sort: 5133,
    },
    passenger_pool_per: '3.56%',
  },
];

const TVShows = () => {
  const [filterData, setFilterData] = useState(data);
  const [filters, setFilters] = useState(defaultUsageFilters);

  useEffect(() => {
    const { searchText } = filters;
    const filteredData = data.filter((obj) => {
      return obj.title.toLowerCase().startsWith(searchText?.toLowerCase());
    });
    setFilterData(filteredData);
  }, [filters]);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-TVShows-Header" className="title_1">
            TV shows
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={filterData}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default TVShows;
